import React from 'react';
import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { SYSTEM_ADMIN_PATH } from '../../../../constants';

const Products = React.lazy(() => import('../TrainingProducts'));
const CreateTrainingProduct = React.lazy(() => import('./TrainingProduct/Create'));
const TrainingProductDetails = React.lazy(() => import('./TrainingProduct/Details'));
const EditTrainingProduct = React.lazy(() => import('./TrainingProduct/Edit'));

const GetProductDetails = () => {
     const productDetails = useSelector((state) => state.admin.productDetails);

     return <span>{productDetails?.name || '...'}</span>;
};

const routes = {
     path: SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS,
     breadcrumb: 'Training Products',
     element: <Outlet />,
     children: [
          { index: true, element: <Products /> },
          {
               path: SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_CREATE,
               breadcrumb: 'Create Product',
               element: <CreateTrainingProduct />,
          },
          {
               path: SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL,
               breadcrumb: GetProductDetails,
               element: <TrainingProductDetails />,
          },
          {
               path: SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_UPDATE,
               element: <EditTrainingProduct />,
          },
     ],
};

export default routes;
